<template>
    <div class="flex items-center gap-2 border-b border-subtle px-5 py-4">
        <PhCalendarDots weight="bold" class="size-5 shrink-0 intent-accent text-subtler" aria-hidden="true" />
        <h2 class="text-display-ui-6 text-strong">
            Select a session<span v-if="ageRestrictionLabel" class="font-normal text-subtle"> · {{ ageRestrictionLabel }}</span>
        </h2>
    </div>
</template>

<script>
import {PhCalendarDots} from "@phosphor-icons/vue";

export default {
    name: "EventV2SessionPickerHeader",
    components: {PhCalendarDots},
    props: {
        ageRestrictionLabel: {type: String, default: ""},
    },
};
</script>
